// @flow
import React from 'react';
import HitLabel from '../HitLabel/HitLabel';
import type {Badge} from '../HitInfo/HitInfo';
import {PP_ACCEPTED, FREE_CANCELLATION} from '../../constants/badges';

type Props = {
    premierPartnerBadge?: ?Badge,
    rankedBadges: Badge[],
    brand?: string,
    tooltipParentNode?: Object,
    isDesktop?: boolean,
    isDualPrice?: boolean
};

const RankedBadgesCollection = ({
    rankedBadges,
    brand,
    tooltipParentNode,
    isDesktop,
    isDualPrice
}: Props) => {
    let badges = rankedBadges.filter((badge) => badge.id !== FREE_CANCELLATION);

    if (!isDualPrice) {
        badges = badges.filter((badge) => badge.id !== PP_ACCEPTED);
    }

    return (
        badges.length > 0 && (
            <div className="HitInfo__labels">
                {badges.map((badge, index) =>
                    isDesktop ? (
                        <HitLabel
                            key={index}
                            brand={brand}
                            id={badge.id}
                            label={badge.name}
                            toolTipText={badge.helpText}
                            parentNode={tooltipParentNode}
                        />
                    ) : (
                        <HitLabel
                            key={index}
                            id={badge.id}
                            label={badge.name}
                        />
                    )
                )}
            </div>
        )
    );
};

export default RankedBadgesCollection;
